import React from "react";
import { useBillingGateSurface } from "./useBillingGateSurface";

interface EddmStepBillingGateProps {
  clientId: string | number | undefined;
  surface: string;
}

export const EddmStepBillingGate = ({ clientId, surface }: EddmStepBillingGateProps) => {
  const billingGate = useBillingGateSurface(clientId === undefined ? undefined : String(clientId));
  const banner = billingGate.renderBanner(surface);
  return (
    <>
      {banner && <div className="px-5 pb-4">{banner}</div>}
      {billingGate.drawer}
    </>
  );
};
